module.exports = __webpack_public_path__ + "img/symbol_1.c15ff5ee.png";